import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

import { MessageDialog, MessageDialogConfiguration } from '@celum/common-components/dialog';

@Component({
  selector: 'celum-format-change-warning',
  templateUrl: './change-warning.component.html',
  styleUrl: './change-warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, MatCheckbox, MessageDialog, TranslatePipe]
})
export class ChangeWarningComponent {
  protected messageDialogConfig = MessageDialogConfiguration.createWarnConfig('CHANGE_WARNING.DIALOG.MESSAGE', 'CHANGE_WARNING.DIALOG.TITLE')
    .withButtons(['ok', 'cancel'])
    .withOkButtonText('CHANGE_WARNING.DIALOG.SAVE_CHANGES')
    .withOkButtonAction(() => this.closeDialog('ok'))
    .withCancelButtonAction(() => this.closeDialog('cancel'))
    .withDisableOnCancelClosing()
    .withDisableOnConfirmClosing();

  protected dontShowAgain = signal(false);

  private matDialogRef = inject(MatDialogRef<ChangeWarningComponent, ChangeWarningResult>);

  private closeDialog(action: 'ok' | 'cancel'): void {
    this.matDialogRef.close({ action, dontShowAgain: this.dontShowAgain() });
  }
}

export interface ChangeWarningResult {
  action: 'ok' | 'cancel';
  dontShowAgain: boolean;
}
